import styles from './style.module.css';
import Button from "skin/entry/cmp/button";
import Icon from "skin/entry/cmp/icon";

export default function Item({ err, disabled, text, icon, onClick, children }) {
	if (text || onClick) {
		const off = !onClick || disabled;
		return <div className={styles.item}>
			{children}
			<Button tabIndex='-1' disabled={off} mini type='base' onClick={onClick}>
				<Icon name={icon} color={off ? 'var(--layer2)' : 'var(--text2)'} />
				{text}
			</Button>
		</div>;
	}
	if (icon) return <div className={styles.item}>
		{children}
		<Icon name={icon} color={err ? 'var(--error)' : 'var(--accent)'} />
	</div>;
	if (!children) return;
	return <div className={styles.item}>{children}</div>;
}